import { render, staticRenderFns } from "./ImportFgcView.vue?vue&type=template&id=7bf10d02"
import script from "./ImportFgcView.vue?vue&type=script&lang=js"
export * from "./ImportFgcView.vue?vue&type=script&lang=js"
import style0 from "./ImportFgcView.vue?vue&type=style&index=0&id=7bf10d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports